// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/mainMenu/mainMenuCtrl.js#1 $
'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:tcMainMenuCtrl
* @description
* Main menu is displayed in left off-canvas panel.
*/
angular.module('tcApp')
.controller('tcMainMenuCtrl', function($scope, $window, $location, $rootScope, $route, $mdMedia, $mdSidenav,
										tcConstants, GlobalService, WorkflowService, MenuService, PerformanceService, $log) {
	var $ctrl = this;
	
	$ctrl.$onInit = function() {
		$ctrl.data = {};
		$ctrl.viewModel = {
			searchText: '',
			menu: {},
			allowTools: false,
			displayTools: false,
			isMainMenuOpen: false,
		};
		
		$mdSidenav('mainMenu', true).then(function(instance) {
			instance.onClose(function() {
				GlobalService.onModalToggle(false);
				mainMenuFocusHandler();
				$rootScope.$broadcast('Component:recalcDynamicColumns');
			});	
		});
		
		$scope.$watch('$ctrl.viewModel.searchText', applySearchText);
		
		// Catch Global:userLogon event broadcasted by GlobalService
		$scope.$on('Global:userLogon', function(event, sessionData) {
			$ctrl.data = sessionData;
			if (angular.isDefined($ctrl.data.menuData.toolsMenu)) {
				$ctrl.viewModel.allowTools = sessionData.logonData.displayStaticTools;
			}
			applySearchText();
		});
	};
	
	// Handle focus when main menu is closed
	var mainMenuFocusHandler = function() {
		var menuButtonElement = $window.document.getElementById('tc_NavBar-misc-menuButton');
		if (angular.isElement(menuButtonElement)) {
			menuButtonElement.focus();
		}
	};
	
	// Use current search input text and filter menus
	var applySearchText = function() {
		if (!$ctrl.data || !$ctrl.data.menuData) return;

		var currentMenu;
		if (angular.isUndefined($ctrl.data.menuData.mainMenu)) {
			// If no main menu is configured, default to tools menu
			currentMenu = $ctrl.data.menuData.toolsMenu;
		} else {
			// If main menu configured, display based on flag
			if ($ctrl.viewModel.displayTools) {
				currentMenu = $ctrl.data.menuData.toolsMenu;
			} else {
				currentMenu = $ctrl.data.menuData.mainMenu;
			}
		}
		if (angular.isUndefined(currentMenu)) return;

		if ($ctrl.viewModel.searchText == '') {
			$ctrl.viewModel.menu = angular.copy(currentMenu);
		} else {
			$ctrl.viewModel.menu = {subMenus: []};
			var resultsExist = filterMenu(currentMenu, $ctrl.viewModel.searchText.toLowerCase());
			if (!resultsExist) {
				var announceMsg = GlobalService.getGlobalStrings()['XNOMATCHES'];
				GlobalService.announce(announceMsg, 'assertive');
			}
		}
		
	};
	
	// Filter a menu and submenus based on the search text
	var filterMenu = function(menu, searchText) {
		var exists = 0;
		if (!menu.subMenus && menu.caption.toLowerCase().indexOf(searchText) != -1) {
			var newMenu = angular.copy(menu);
			newMenu.level = 1;
			newMenu.subMenuIndex = $ctrl.viewModel.menu.subMenus.length;
			$ctrl.viewModel.menu.subMenus.push(newMenu);
			exists = 1;
		}
		if (!menu.subMenus) return exists;
		
		for (var i = 0; i < menu.subMenus.length; i++) {
			exists = filterMenu(menu.subMenus[i], searchText) || exists;
		}
		return exists;
	};

	// Handle menu navigation, called by child menu component
	$ctrl.onClick = function(menu) {
		var linkUrl = menu.linkUrl;
		if (linkUrl) {
			$mdSidenav('mainMenu').close();
			$ctrl.viewModel.searchText = '';
			if (menu.externalUrl) {
				GlobalService.openWindow(linkUrl, menu.name, menu.windowSpecs);
				return;
			}
			WorkflowService.mainMenuData = {caption: menu.caption};
			linkUrl = linkUrl 
				+ (linkUrl.indexOf('?') > -1 ? '&' : '?') + 'Dialog=0';
			PerformanceService.onMenu(menu.id);
			if (linkUrl === decodeURI($location.url())) {
				$rootScope.$broadcast('tcMenu:MainMenuSelected', menu.caption);
				$route.reload();
			} else {
				$location.url(linkUrl);
			}
		}
	};
	
	// Handle key press on a menu
	$ctrl.onKeyPress = function($event, parentMenu, currentMenu, collapsed, rootId) {
		if (($event.keyCode === tcConstants.KEY_CODE.DOWN_ARROW) || ($event.keyCode === tcConstants.KEY_CODE.UP_ARROW)) {
			$event.preventDefault();
			if (angular.isUndefined(parentMenu)) parentMenu = $ctrl.viewModel.menu;
			MenuService.handleMenuKeydown($event, $ctrl.viewModel.menu, parentMenu,
											currentMenu, collapsed, rootId, $event.keyCode);
		}
	};
	
	// Handle key press in the search input
	$ctrl.onSearchKeyPress = function($event) {
		if ($event.keyCode !== tcConstants.KEY_CODE.ENTER) return;
		$ctrl.onClick($ctrl.viewModel.menu.subMenus[0]);
	};
	
	// Return to search if user tabs out of menu
	$ctrl.wrapFocus = function() {
		var searchElement = $window.document.getElementById('tc_MainMenu-misc-search');	
		if (angular.isDefined(searchElement)) searchElement.focus();
	};
	
	// Return whether the search input should be focused
	$ctrl.shouldFocusSearch = function() {
		return !GlobalService.isTouchDevice();
	};
	
	// Toggles between the main menu header and side menus
	$ctrl.toggleTools = function(value) {
		if (angular.isDefined(value)) {
			$ctrl.viewModel.displayTools = value;
		} else {
			$ctrl.viewModel.displayTools = !$ctrl.viewModel.displayTools;
		}
		applySearchText();
		$ctrl.wrapFocus();
	};
	
	// Catch the event from GlobalService to reset the menu
	$scope.$on('Global:setMenuTools', function($event, newDisplayToolsValue) {
		$ctrl.toggleTools(newDisplayToolsValue);
	});
	
	$scope.$on('Global:sessionLocked', function() {
		$mdSidenav('mainMenu').close();
	});

	$scope.$on('Global:callFunction', function(event, componentHtmlName,
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'MainMenu') return;

		if (angular.isFunction($ctrl[functionName])) {
			var returnValue = $ctrl[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, 'controller');
		}
	});

});
